(function () {
  const discountCodes = document.querySelectorAll("[data-discount-copy]");
  if (discountCodes.length > 0) {
    discountCodes.forEach((elem) => {
      elem.addEventListener("click", (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(elem.dataset.discountCopy || "");
        e.target.classList.add("active");
        setTimeout(() => {
          e.target.classList.remove("active");
          e.target.blur();
        }, 1500);
      });
    });
  }
})();

function checkAndUpdateScrolling() {
  const body = document.body;
  const html = document.documentElement;

  if (body.classList.contains("product-samples-widget--active")) {
    html.style.overflow = "auto";
    html.style.paddingRight = "0px";
    html.style.boxSizing = "content-box";
  } else {
    html.style.overflow = "";
    html.style.paddingRight = "";
    html.style.boxSizing = "";
  }
}

const observer = new MutationObserver(checkAndUpdateScrolling);

observer.observe(document.body, {
  attributes: true,
  attributeFilter: ["class"],
});

checkAndUpdateScrolling();

/*
  Close Description tab on PDP Mobile on page load

*/

document.addEventListener("DOMContentLoaded", () => {
  let productTabs = document.querySelectorAll(".pxu-tabs .tab-radio");
  //no product tabs
  if (productTabs == null || productTabs.length < 1) {
    return;
  }
  // not mobile
  if (window.innerWidth > 720) {
    return;
  }

  productTabs.forEach((tab) => {
    tab.checked = false;
    if (tab.id == "description-tab-related") {
      tab.checked = true;
    }
  });
});
